import React from 'react';
import { FAQListItem, FAQQuestion, PlusMinus } from './styles';

interface FAQItemProps {
  index: number;
  question: string;
  isActive: boolean;
  onClick: () => void;
}

const FAQItem: React.FC<FAQItemProps> = ({
  index,
  question,
  isActive,
  onClick
}) => {
  return (
    <FAQListItem
      role="tab"
      id={`faq-tab-${index}`}
      aria-controls={`faq-panel-${index}`}
      aria-selected={isActive}
      $active={isActive}
      onClick={onClick}
    >
      <FAQQuestion>{question}</FAQQuestion>
      <PlusMinus aria-hidden $open={isActive}>{isActive ? '−' : '+'}</PlusMinus>
    </FAQListItem>
  );
};

export default FAQItem;
